import React from 'react';
import IconFacebook from "@/components/icons/Facebook";
import IconXformerlytwitter from "@/components/icons/Xformerlytwitter";
import IconInstagram from "@/components/icons/Instagram";
import IconDiscord from "@/components/icons/Discord";
import IconLinkedin from "@/components/icons/Linkedin";
import IconTiktok from "@/components/icons/Tiktok";
import IconYoutube from "@/components/icons/Youtube";
import IconTelegram from "@/components/icons/Telegram";
import IconPinterest from "@/components/icons/Pinterest";
import IconMedium from "@/components/icons/Medium";
import IconAt from "@/components/icons/At";
import IconStrava from "@/components/icons/Strava";
import IconProducthunt from "@/components/icons/Producthunt";
import IconReddit from "@/components/icons/Reddit";
import ContainerHorizontal from './ContainerHorizontal';
import { useTranslation } from 'react-i18next';

const FollowUs = () => {
    const { t } = useTranslation();
    const socialLinks = [
        { href: "https://www.strava.com/clubs/1697031/leaderboard", label: "Strava", Icon: IconStrava, hoverColor: "#FC4C02" },
        { href: "https://www.youtube.com/@themynawoo/", label: "YouTube", Icon: IconYoutube, hoverColor: "#FF0000" },
        { href: "https://www.instagram.com/themynawoo/", label: "Instagram", Icon: IconInstagram, hoverColor: "#E1306C" },
        { href: "https://www.facebook.com/profile.php?id=61572886085442", label: "Facebook", Icon: IconFacebook, hoverColor: "#1877F2" },
        { href: "https://www.tiktok.com/@themynawoo", label: "TikTok", Icon: IconTiktok, hoverColor: "#27ccc6" },
        { href: "https://www.pinterest.com/themynawoo/", label: "Pinterest", Icon: IconPinterest, hoverColor: "#E60023" },
        { href: "https://medium.com/@themynawoo", label: "Medium", Icon: IconMedium, hoverColor: "#00ab6c" },
        // { href: "https://themynawoo.blogspot.com/", Icon: IconShare },
        { href: "https://t.me/themynawoo", label: "Telegram", Icon: IconTelegram, hoverColor: "#0088cc" },
        // { href: "https://t.me/themynawoo_bot", Icon: IconTelegram, hoverColor: "#0088cc" },
        { href: "https://www.linkedin.com/company/themynawoo/", label: "LinkedIn", Icon: IconLinkedin, hoverColor: "#0077b5" },
        { href: "https://x.com/themynawoo", label: "X", Icon: IconXformerlytwitter, hoverColor: "#ffd084" },
        // { href: "https://discord.gg/a3MBUFae", Icon: IconDiscord, hoverColor: "#7289da" },
        { href: "https://discord.gg/5dhkkcyT", label: "Discord", Icon: IconDiscord, hoverColor: "#7289da" },
        { href: "https://www.producthunt.com/@themynawoo", label: "Product Hunt", Icon: IconProducthunt, hoverColor: "#DA552F" },
        { href: "https://www.reddit.com/user/Radiant_Aioli_5026/", label: "Reddit", Icon: IconReddit, hoverColor: "#FF4500" },
    ];

    const handleCopyEmail = () => {
        navigator.clipboard.writeText("support@mynawoo.com")
            .then(() => {
                void import('react-toastify').then(({ toast }) => {
                    toast.success(t('contact.email_copied'));
                });
            })
            .catch((err) => {
                console.error("Failed to copy email: ", err);
            });
    };

    return (
        <ContainerHorizontal className="gap-2 whitespace-nowrap">
            <p>{t('common.follow_us')}</p>
            {socialLinks.map(({ href, label, Icon, hoverColor }) => (
                <a
                    key={href}
                    href={href}
                    aria-label={`Follow Mynawoo on ${label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-opacity"
                    onMouseEnter={(e) => (e.currentTarget.style.color = hoverColor)}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                >
                    <Icon />
                </a>
            ))}
            <button
                type="button"
                onClick={handleCopyEmail}
                className="flex items-center justify-center transition-opacity"
                title={t('common.copy_support_email')}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#7A5DE4")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
            >
                <IconAt />
            </button>
        </ContainerHorizontal>
    );
};

export default FollowUs;
